/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleLeftIcon20Regular = forwardRef('ArrowFigureACircleLeftIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M14 10a.75.75 0 0 0-.75-.75H8.056l2.009-1.674a.75.75 0 0 0-.96-1.152L6.427 8.656c-.84.7-.84 1.989 0 2.688l2.679 2.232a.75.75 0 0 0 .96-1.152L8.057 10.75h5.192A.75.75 0 0 0 14 10Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.999 10A7.999 7.999 0 1 0 2 10 7.999 7.999 0 0 0 18 10ZM10 3.501A6.499 6.499 0 1 1 10 16.5 6.499 6.499 0 0 1 10 3.5Z" })));
});
